import { createSlice } from '@reduxjs/toolkit';

import { dataReviewer } from '../../../../services/dataReviewerApi/dataReviewerApi';

import { startTestApi } from './../../../../services/startTestAPI/startTestApi';

export type DataReviewerQuestionType = {
  id: string;
  isActive: boolean;
  createdDate: string;
  updatedDate: string | null;
  examType: string;
  readingPassage: string;
  readingPassageTitle: string | null;
  questionText: string;
  optionA: string;
  optionB: string;
  optionC: string;
  optionD: string;
  correctAnswer: string;
  explanation: string | null;
  sourceFile: string;
  domain: string;
  subTopic: string;
  sourceText: string;
  questionType: string;
  year: number | null;
  isCodingQuestion: boolean;
  isApproved: boolean;
  audit: unknown | null;
  module?: string;
  options?: any;
  isProgrammingQuestion: boolean;
  difficultyLevel: string;
  comment?: string;
  additionalProps?: any;
};

export type QuestionStats = {
  questionsbyquestionstatus: Record<string, number>;
  questionsbyquestionmodule: Record<string, number>;
  questionsbyquestiondomain: Record<string, number>;
  questionsbyquestiondomainandsubdomain: Record<string, Record<string, number>>;
  questionsbyquestionsource: Record<string, number>;
};

type initialStateType = {
  underReviewAndRejectedData: {
    data: DataReviewerQuestionType[];
    totalquestions: number;
    currentpage: number;
  };
  sourceNames?: [];
  sectionsData?: [];
  topicsData?: [];
  questionTypesData?: [];
  selectedSection?: any;
  selectedSource?: any;
  selectedTopic?: any;
  selectedQuestionType?: any;
  searchString: string;
  programmingTopicsData?: [];
  selectedProgramingType?: any;
  allReports: QuestionStats;
};

const initialState: initialStateType = {
  underReviewAndRejectedData: {
    data: [],
    totalquestions: 0,
    currentpage: 0
  },
  sourceNames: [],
  sectionsData: [],
  topicsData: [],
  questionTypesData: [],
  selectedSource: {},
  selectedSection: {},
  selectedTopic: {},
  selectedQuestionType: {},
  programmingTopicsData: [],
  selectedProgramingType: {},
  searchString: '',
  allReports: {
    questionsbyquestionstatus: {},
    questionsbyquestionmodule: {},
    questionsbyquestiondomain: {},
    questionsbyquestiondomainandsubdomain: {},
    questionsbyquestionsource: {}
  }
};

const dataReviewerSlice = createSlice({
  name: 'dataReviewer',
  initialState,
  reducers: {
    setSelectedSourceName: (state, action) => {
      state.selectedSource = action.payload;
    },
    setSelectedSection: (state, action) => {
      state.selectedSection = action.payload;
    },
    setSelectedTopic: (state, action) => {
      state.selectedTopic = action.payload;
    },
    setSelectedQuestionType: (state, action) => {
      state.selectedQuestionType = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchString = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      dataReviewer.endpoints.getIsUnderReview.matchFulfilled,
      (state, action) => {
        state.underReviewAndRejectedData = action.payload;
      }
    );
    builder.addMatcher(
      dataReviewer.endpoints.fetchSourceNames.matchFulfilled,
      (state, action) => {
        state.sourceNames = action.payload.data;
      }
    );
    builder.addMatcher(
      dataReviewer.endpoints.fetchReports.matchFulfilled,
      (state, action) => {
        state.allReports = action.payload.data;
      }
    );
    builder.addMatcher(
      dataReviewer.endpoints.getAllCmsSectionsData.matchFulfilled,
      (state, action) => {
        state.sectionsData = action.payload.data;
      }
    );
    builder.addMatcher(
      dataReviewer.endpoints.fetchTopicsBySection.matchFulfilled,
      (state, action) => {
        state.topicsData = action.payload.data;
      }
    );
    builder.addMatcher(
      dataReviewer.endpoints.fetchQuestionTypes.matchFulfilled,
      (state, action) => {
        state.questionTypesData = action.payload.data;
      }
    );
    builder.addMatcher(
      startTestApi.endpoints.getProgrammingTopics.matchFulfilled,
      (state, action) => {
        state.programmingTopicsData = action.payload.data;
      }
    );
  }
});

export const {
  setSelectedSourceName,
  setSelectedSection,
  setSelectedTopic,
  setSelectedQuestionType,
  setSearchString
} = dataReviewerSlice.actions;
export default dataReviewerSlice.reducer;
